import HackleCore from "../../../core/HackleCore"
import { InAppMessageLayoutEvaluator } from "../../../core/internal/evaluation/evalautor/iam/layout/InAppMessageLayoutEvaluator"
import { InAppMessageLayoutRequest } from "../../../core/internal/evaluation/evalautor/iam/layout/InAppMessageLayoutRequest"
import { InAppMessageLayoutEvaluation } from "../../../core/internal/evaluation/evalautor/iam/layout/InAppMessageLayoutEvaluation"
import Workspace from "../../../core/internal/workspace/Workspace"
import { InAppMessage } from "../../../core/internal/model/model"
import { HackleUser } from "../../../core/internal/model/model"
import { EvaluatorContext } from "../../../core/internal/evaluation/evalautor/Evaluator"

export class InAppMessageLayoutResolver {
  constructor(private readonly core: HackleCore, private readonly layoutEvaluator: InAppMessageLayoutEvaluator) {}

  resolve(workspace: Workspace, inAppMessage: InAppMessage, user: HackleUser): InAppMessageLayoutEvaluation {
    const request = new InAppMessageLayoutRequest(workspace, user, inAppMessage)
    return this.core.inAppMessage(request, EvaluatorContext.create(), this.layoutEvaluator)
  }
}
